
export const ProjectSection = () => {
  const highlights = [
    {
      icon: 'ri-leaf-line',
      title: '친환경 혁신',
      description: '해양 폐기물을 활용한 100% 생분해성 소재 개발'
    },
    {
      icon: 'ri-microscope-line',
      title: '첨단 기술',
      description: '나노 바이오 기술과 AI 기반 연구개발 시스템'
    },
    {
      icon: 'ri-global-line',
      title: '글로벌 시장',
      description: '세계 바이오소재 시장 $500B 규모의 성장 잠재력'
    },
    {
      icon: 'ri-award-line',
      title: '검증된 성과',
      description: '국제 특허 12건, 정부 인증 획득'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            왜 MarineBioGroup에 투자해야 할까요?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            우리는 해양 생명공학 분야의 선도 기업으로, 지속 가능한 미래를 위한 혁신적인 솔루션을 개발하고 있습니다.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src="https://readdy.ai/project/36601293-3225-4aaf-b874-afc33c6d03c6/assets/images/research-lab.jpg"
              alt="연구실"
              className="w-full h-96 object-cover rounded-2xl shadow-lg"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              혁신적인 연구개발 시설
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              최첨단 바이오 연구 시설과 AI 기반 분석 시스템을 통해 
              해양 미생물에서 추출한 천연 소재를 활용한 
              친환경 제품을 개발하고 있습니다.
            </p>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-700">
                <i className="ri-check-line text-green-600 mr-3"></i>
                ISO 14001 환경경영시스템 인증
              </li>
              <li className="flex items-center text-gray-700">
                <i className="ri-check-line text-green-600 mr-3"></i>
                FDA 승인 생산 시설
              </li>
              <li className="flex items-center text-gray-700">
                <i className="ri-check-line text-green-600 mr-3"></i>
                국제 특허 보유 기술력
              </li>
            </ul>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          {highlights.map((item, index) => (
            <div key={index} className="text-center p-6 rounded-xl border border-gray-100 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-2xl text-blue-600`}></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">{item.title}</h4>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
